export default class wdkInputCheckobx extends HTMLElement {
	static get observedAttributes() {
		return ['disabled'];
	}

	attributeChangedCallback(name) {
		this.#handleAttributeChange(name);
	}

	connectedCallback() {
		this.abortController = new AbortController();
		this.#prepareDom();
		this.inputElement = this.querySelector('.inputWrapper input');
		this.#handleAttributeChange();
		this.#handleInputEventListeners();
	}

	disconnectedCallback() {
		this.abortController?.abort();
		this.#cleanupDom();
	}

	#handleAttributeChange(name) {
		//when called from attributeChangedCallback directly our DOM is not yed finished
		if (this.inputElement !== undefined) {
			if (name === 'disabled' || this.hasAttribute('disabled')) {
				this.inputElement.disabled = this.hasAttribute('disabled');
			}
		}
	}

	#prepareDom() {
		const rawHtml = document.createElement('template');
		const isSwitch = this.getAttribute('switch') !== null;
		const isReverse = this.getAttribute('reverse') !== null;
		rawHtml.innerHTML = `
			<div class="designWrapper ${this.#sanitizeEvilHtml(isReverse ? 'reverse' : '')}">
				<div class="inputWrapper ${this.#sanitizeEvilHtml(isSwitch ? 'switch' : '')}">
					<input type="checkbox" />
					${this.#sanitizeEvilHtml(isSwitch ? '<div class="switchSlider"><div class="switchBg"></div><div class="switchKnob"></div></div>' : '')}
				</div>
				<div class="labelWrapper">
					<label for="${this.#sanitizeEvilHtml(this.#getId())}Input"></label>
				</div>
			</div>
			<div class="errors"></div>
  		`;

		const dataTemplate = this.querySelector('template');
		if (dataTemplate) {
			this.appendChild(rawHtml.content);
			const templateContent = document.importNode(dataTemplate.content, true);

			this.#fillLabel(templateContent);
			this.#fillInput(templateContent);
			this.#fillErrors(templateContent);
		}
	}

	//Important if Component is moved within the Dom
	#cleanupDom() {
		const children = Array.from(this.children);
		children.forEach((child) => {
			if (child.tagName.toLowerCase() !== 'template') {
				child.remove();
			}
		});
	}

	#handleInputEventListeners() {
		this.inputElement.addEventListener('input', () => {
			if (this.inputElement.checkValidity()) {
				this.hideErrors();
			}
		});

		/*blur focus mouseenter mouseleave load unload do not bubble up the tree */
		this.inputElement.addEventListener('blur', () => {
			if (this.inputElement.checkValidity()) {
				this.hideErrors();
			}
		});

		this.inputElement.addEventListener('invalid', () => {
			this.hideErrors();
			this.#showFrontendError();
		});
	}

	#showFrontendError() {
		const errorTypes = [
			{ type: 'valueMissing', condition: /* @type {ValidityState} */ this.inputElement.validity.valueMissing },
			{ type: 'rangeOverflow', condition: /* @type {ValidityState} */ this.inputElement.validity.rangeOverflow },
			{ type: 'generic', condition: true },
		];

		for (const errorType of errorTypes) {
			const errorElement = this.querySelector(`wdk-hintbox-error[frontend-error="${errorType.type}"]`);
			if (errorType.condition && errorElement) {
				errorElement.show();
				break;
			}
		}
	}

	showBackendError(errorState) {
		const errorElement = this.querySelector(`wdk-hintbox-error[backend-error="${errorState}"]`);
		if (errorElement !== null) {
			this.hideErrors();
			errorElement.show();
		}
	}

	hideErrors() {
		this.querySelectorAll('.errors wdk-hintbox-error').forEach((error) => {
			error.hide();
		});
	}

	getValue() {
		return this.inputElement.value;
	}

	#getId() {
		if (this.getAttribute('id')) {
			return this.getAttribute('id');
		} else {
			console.error('No id specified!');
		}
	}

	#fillLabel(templateContent) {
		const labelDiv = templateContent.querySelector('div[data-slot="label"]');
		this.querySelector('.labelWrapper label').innerHTML = this.#sanitizeEvilHtml(labelDiv.innerHTML);

		if (this.getAttribute('invisible-label') !== null) {
			this.querySelector('.labelWrapper').classList.add('visuallyHidden');
		}
	}

	#fillInput(templateContent) {
		const inputElement = templateContent.querySelector('div[data-slot="input"]');
		if (inputElement) {
			this.querySelector('.inputWrapper input').outerHTML = this.#sanitizeEvilHtml(inputElement.innerHTML);
			this.querySelector('.inputWrapper input').id = this.#getId() + 'Input';
		} else {
			this.querySelector('.inputWrapper input').remove();
			console.error('No input element specified!');
		}
	}

	#fillErrors(templateContent) {
		const errors = templateContent.querySelector('div[data-slot="errors"]');
		if (errors) {
			this.querySelector('.errors').innerHTML = this.#sanitizeEvilHtml(errors.innerHTML);
		} else {
			this.querySelector('.errors').remove();
		}
	}

	#sanitizeEvilHtml(string) {
		return String(string).replace(
			/<script\b|\bonerror=|\bonload=|\bonmouseover=|\bonmouseout=|\bonpagehide=|\bonpageshow=|\bonmessage=|\bonhashchange=|\bonbeforeunload=|\bonpopstate=|\bonresize=|\bonunload=|\bonkeydown=|\bonkeyup=|\bonkeypress=|\bonfocus=|\bonblur=|\bonchange=|\bonsubmit=|\bonreset=|\bonselect=|\bondblclick=|\bondrag=|\bondragend=|\bondragenter=|\bondragleave=|\bondragover=|\bondragstart=|\bondrop=|\bonwheel=|\boncopy=|\boncut=|\bonpaste=|\bonanimationend=|\bonanimationiteration=|\bonanimationstart=|\bontransitionend=|\bontouchcancel=|\bontouchend=|\bontouchmove=|\bontouchstart=|\bonclick=/gi,
			'',
		);
	}
}
